import JusteraLogo from '../../../../assets/img/RJ_V1/Justera_Logo-04-1.png';

const Footer_RJV1 = () => {
  return (
    <>
      <footer className="bg-dark-navy text-white pb-24">
        {/* <!-- Main footer content --> */}
        <div className="container px-3 py-5 d-flex flex-column align-items-center text-center">
            {/* <!-- Logo --> */}
            <img alt="Justera Logo" className="mb-5 brightness-0 invert" src={JusteraLogo} width="180px"/>

            {/* <!-- Legal text --> */}
            <div className="space-y-5 mb-5 small text-gray-300 leading-relaxed">
                <p>Justera is a trading style of Claim Simple Ltd, registered in England and Wales, Company registration
                    number 11459714. Registered Office: The Old Fuel Depot, Twemlow Lane, Holmes Chapel, Crewe, CW4
                    8GJ. Registered with the Information Commissioner's Office; registration number ZA449298. You can
                    find our terms of use, privacy policy and our cookie policy here. Claim Simple Ltd is a claims
                    management company. Any solicitor we recommend you to is an independent professional from whom you
                    will receive impartial and confidential advice. You are free to choose another solicitor.</p>
                <p>Claim Simple is authorised and regulated by the Financial Conduct
                    Authority In respect of claim management activities FRN: 830182</p>
                <p>Any Professional Representative that we refer you to is an independent professional from whom you will receive impartial and confidential advice. You are free to choose alternative representation. Claim Simple may receive a referral fee for your claim, this charge is not incurred by you.</p>
                <p>Where No Win, No Fee is offered – You pay nothing unless your claim is successful. A fee between 18 –
                    36%, including VAT applies on successful claims (fee dependant on level of redress secured), and a
                    cancellation fee may apply outside the 14 day cooling-off period.</p>
                <p className="text-gray-400 fs-12">***All figures disclosed on the results page of our form are based on
                    the FCAs average per agreement payment of £829</p>
               <p className="text-gray-400 fs-12">*<a href="https://www.fca.org.uk/news/statements/fca-consults-motor-finance-compensation-scheme"
                    target="_blank"
                    rel="noopener noreferrer"
                  >https://www.fca.org.uk/news/statements/fca-consults-motor-finance-compensation-scheme</a></p>
            </div>
        </div>

        {/* <!-- Bottom bar --> */}
        <div className="border-top border-white-10">
            <div className="mx-auto px-3 py-4 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 text-gray-400 fw-semibold text-uppercase tracking-wide mw-72rem fs-12">
                <div className="d-flex flex-wrap justify-content-center justify-content-sm-start gap-3">
                    <a target="_blank" href="/terms" className="text-gray-400 text-decoration-none hover-text-white transition-colors">Terms of Service</a>
                    <a target="_blank" href="/privacy-policy" className="text-gray-400 text-decoration-none hover-text-white transition-colors">Privacy Policy</a>
                    <a target="_blank" href="https://justera.co.uk/cookies/" className="text-gray-400 text-decoration-none hover-text-white transition-colors">Cookies</a>
                    <a target="_blank" href="https://justera.co.uk/complaints/" className="text-gray-400 text-decoration-none hover-text-white transition-colors">Complaints</a>
                </div>
                <span className="text-gray-400 normal-case tracking-normal">© Claim Simple Limited 2026</span>
            </div>
        </div>
    </footer>
    </>
  );
};

export default Footer_RJV1;
